import { Environment } from '../Environment';

/**
 * Setup the environment that all the models will be sharing.
 *
 * The environment includes other functions that will be picked from some
 * of the models that get created later. This is how we loosely couple things
 * like events between models.
 */
export async function createEnvironment(): Promise<Environment> {
  return new Environment();
}
